import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../lib/i18n';

const EMAIL = 'katalin@rubedo.info';
const DSB_URL = 'https://www.dsb.gv.at/';
const GESETZE_URL = 'https://www.dsb.gv.at/recht-entscheidungen/gesetze-in-oesterreich.html';

function renderRichText(text) {
  // Replace {site}, {email}, {dsb}, {gesetze} tokens with React nodes.
  const parts = text.split(/(\{site\}|\{email\}|\{dsb\}|\{gesetze\})/g);
  return parts.map((part, i) => {
    if (part === '{site}') {
      return (
        <Link
          key={i}
          to="/"
          className="text-cherry underline underline-offset-4 decoration-cherry/40 hover:decoration-cherry"
        >
          Rubedo
        </Link>
      );
    }
    if (part === '{email}') {
      return (
        <a
          key={i}
          href={`mailto:${EMAIL}`}
          className="text-cherry underline underline-offset-4 decoration-cherry/40 hover:decoration-cherry"
        >
          {EMAIL}
        </a>
      );
    }
    if (part === '{dsb}') {
      return (
        <a
          key={i}
          href={DSB_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-cherry underline underline-offset-4 decoration-cherry/40 hover:decoration-cherry break-all"
        >
          {DSB_URL}
        </a>
      );
    }
    if (part === '{gesetze}') {
      return (
        <a
          key={i}
          href={GESETZE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-cherry underline underline-offset-4 decoration-cherry/40 hover:decoration-cherry break-all"
        >
          {GESETZE_URL}
        </a>
      );
    }
    return part;
  });
}

export default function Privacy() {
  const { t } = useI18n();
  return (
    <main data-testid="privacy-page" className="bg-cream text-ink min-h-screen">
      <div className="max-w-3xl mx-auto px-6 md:px-12 pt-40 md:pt-48 pb-24 md:pb-32">
        <Link
          to="/"
          data-testid="privacy-back-link"
          className="link-underline text-[10px] tracking-[0.4em] uppercase text-cherry hover:text-ink transition-colors mb-12 inline-block font-body"
        >
          ← {t.privacy.back}
        </Link>

        <h1 className="font-display font-medium text-5xl md:text-6xl lg:text-7xl tracking-tight leading-[1] mb-6 text-ink">
          {t.privacy.title}
          <span className="text-cherry">.</span>
        </h1>

        <p className="text-[10px] tracking-[0.4em] uppercase text-ink/50 mb-16 font-body">
          {t.privacy.updated} · {new Date().toLocaleDateString()}
        </p>

        <div className="space-y-12">
          {t.privacy.sections.map((s, i) => (
            <section key={i} data-testid={`privacy-section-${i}`}>
              <h2 className="font-display font-medium text-2xl md:text-3xl mb-4 text-cherry">
                {s.h}
              </h2>
              {(s.paragraphs || (s.p ? [s.p] : [])).map((para, j) => (
                <p
                  key={j}
                  data-testid={`privacy-section-${i}-para-${j}`}
                  className="font-body text-ink/80 text-base md:text-lg leading-relaxed mb-4"
                >
                  {renderRichText(para)}
                </p>
              ))}
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
